import React from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { Link } from "react-router-dom"; // React Router Link
import '../Scc/Navbar.scss'; // Import the SCSS file

const Navbar = () => {
  return (
    <nav className="navbar">
      {/* Logo Section */}
      <motion.div
        className="logo"
        whileHover={{ scale: 1.05 }}
        transition={{ type: "spring", stiffness: 300 }}
      >
        <Link to="/" className="logo-text">
          MBJ Technologies
        </Link>
      </motion.div>

      {/* Navbar Links */}
      <ul className="nav-links">
        {/* <li>
          <Link to="/mbjtech" className="nav-item">
            Home
          </Link>
        </li> */}
        <li>
          <Link to="/about" className="nav-item">
            About
          </Link>
        </li>
        
        {/* Services Dropdown */}
        <li className="dropdown">
          <div className="dropdown-toggle">
            Services <ChevronDown size={16} className="ml-1" />
          </div>
          <motion.div
            className="dropdown-menu"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
          >
            <Link to="/engraving" className="dropdown-item">
              Engraving
            </Link>
            <Link to="/laser-printing" className="dropdown-item">
              Laser Printing
            </Link>
          </motion.div>
        </li>

        {/* Other Links */}
        <li>
          <Link to="/inquiry" className="nav-item">
            Inquiry
          </Link>
        </li>
        <li>
          <Link to="/contact" className="nav-item">
            Contact
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
